// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Context-specific styles (Your original Host-based styles, with updated selectors) --- */
:host {
  border-radius: var(--border-radii);
}

:host ::ng-deep .foodTypeLabel2 {
  border-radius: var(--border-radii);
}

:host ::ng-deep .button {
  min-height: 100%;
}

:host ::ng-deep .inText {
  color: var(--text-color);
  text-align: center;
}

:host ::ng-deep .inData {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.metaBox:host ::ng-deep .inData {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 0 1vw;
  font-size: 12px;
}

.loyaltyContainer:host ::ng-deep .inData {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 0 1vw;
}

.manual-move-btn:host ::ng-deep .inData {
  font-size: 12px;
  padding: 0 1vh;
}

.rowContent:host ::ng-deep .inData {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2vw;
  width: 100%;
}
.rowContent:host ::ng-deep .inData .inText {
  height: calc(100% - 28vw);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all var(--anim--hover-time) ease-in-out;
}

.colContent:host ::ng-deep .inData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2vw;
  width: 100%;
}
.colContent:host ::ng-deep .inData .inText {
  height: calc(100% - 24vw);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0vw 0 2vw 0;
}

:host ::ng-deep .inData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2vw;
  width: 100%;
  position: relative;
  display: flex;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  letter-spacing: 1px;
  font-weight: 500;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all 0.3s ease-in-out;
  padding: 1vw 2vw;
}

:host ::ng-deep .inIcon {
  background-color: transparent;
  border: none;
  stroke: var(--text-color);
  fill: var(--text-color);
  height: 4vh;
  width: 4vh;
}

:host ::ng-deep .inImg {
  background-color: transparent;
  border: none;
  height: 24vw;
  width: 24vw;
  object-fit: fill;
}

:host ::ng-deep .conImg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: transparent;
  border: none;
  height: 7vh;
  width: 100%;
  object-fit: cover;
}

.foodTypeLabel:host {
  pointer-events: all;
  height: 3vh;
  max-height: 3vh;
  min-height: 3vh;
  box-shadow: none;
}
.foodTypeLabel:host .button {
  height: 3vh;
  max-height: 3vh;
  min-height: 3vh;
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.foodTypeLabel:host .button .inData {
  display: flex;
  flex-direction: row;
  pointer-events: all;
  color: var(--text-color);
  max-height: 3vh;
  padding: 0;
}

.doubleBtn:host .button .inData {
  padding: 1vw;
}

.box1:host .button .inData {
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: row-reverse;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  letter-spacing: 1px;
  font-size: 14px;
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all var(--anim--hover-time) var(--anim--hover-ease);
  gap: 0;
  min-height: 100%;
}

.box2:host .button .inData {
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: row;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  letter-spacing: 1px;
  font-size: 14px;
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all var(--anim--hover-time) var(--anim--hover-ease);
  min-height: 100%;
  gap: 0;
}

.removeDB:host .button .inData {
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  letter-spacing: 1px;
  font-size: 14px;
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all var(--anim--hover-time) var(--anim--hover-ease);
  padding: 0vw;
  min-height: 100%;
}

.modalFooter :host .button {
  min-width: 8vw;
}
.modalFooter :host .button .button-glass {
  padding: 1vw 2vw;
}
.modalFooter :host .button .button-icon {
  height: 6vw;
  width: 6vw;
}

.action-button {
  pointer-events: all;
  height: 3vh;
  max-height: 3vh;
  min-height: 3vh;
}
.action-button :host {
  pointer-events: all;
  height: 3vh;
  max-height: 3vh;
  min-height: 3vh;
}
.action-button :host .button {
  height: 3vh;
  max-height: 3vh;
  min-height: 3vh;
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.action-button :host .button .inData {
  display: flex;
  flex-direction: row;
  pointer-events: all;
  color: var(--text-color);
  max-height: 3vh;
  padding: 0vh 1vh;
  gap: 1vh;
}
.action-button :host .button .inData .shotcutIcon {
  stroke: var(--text-color);
  fill: none;
}
.action-button :host .button .inData .item {
  color: var(--text-color);
}

.delete-button :host .button {
  min-width: 7vw;
  border-radius: 15px;
  height: 6vw;
  min-height: auto;
  padding: 0;
  border: 1px solid var(--ion-color-danger);
}
.delete-button :host .button .button-glass {
  padding: 1vw 2vw;
}
.delete-button :host .button .button-content {
  gap: 0vw;
}
.delete-button :host .button .button-icon {
  height: 5vw;
  width: 5vw;
  margin: 0;
  padding: 0;
}

.delete-button {
  pointer-events: all;
  width: 3vh;
  height: 3vh;
  max-width: 3vh;
  max-height: 3vh;
  min-width: 3vh;
  min-height: 3vh;
}
.delete-button :host {
  pointer-events: all;
  width: 3vh;
  height: 3vh;
  max-width: 3vh;
  max-height: 3vh;
  min-width: 3vh;
  min-height: 3vh;
}
.delete-button :host .button {
  width: 3vh;
  height: 3vh;
  max-width: 3vh;
  max-height: 3vh;
  min-width: 3vh;
  min-height: 3vh;
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.delete-button :host .button .inData {
  display: flex;
  flex-direction: row;
  pointer-events: all;
  color: var(--text-color);
  max-width: 3vh;
  max-height: 3vh;
  padding: 0.5vh;
}
.delete-button :host .button .inData .shotcutIcon {
  stroke: var(--text-color);
  fill: none;
}
.delete-button :host .button .inData .item {
  color: var(--text-color);
}

.header :host {
  background: none;
}
.header :host .button {
  font-size: 12px !important;
  padding: 0;
  min-height: auto;
}
.header :host .button .button-glass {
  padding: 1vw 4vw;
}
.header :host .button .button-content {
  gap: 2vw;
}
.header :host .button .button-icon {
  height: 4vw;
  width: 4vw;
}

.newPost:host {
  box-shadow: var(--shadow-side-anim-end);
}
.newPost:host .label {
  margin: 1vw 2vw;
  letter-spacing: 2px;
  font-size: 14px;
}

.form-footer :host .button {
  border-radius: 20px;
  overflow: hidden;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 4vh;
  min-height: auto;
  padding: 0;
}
.form-footer :host .button .button-glass {
  padding: 1vw 2vw;
}
.form-footer :host .button-icon {
  height: 3vh;
  width: 4vh;
  margin: 1vw;
}
.form-footer :host .label {
  margin: 0 2vw;
}

.smartPlan :host .button {
  height: 5vh;
  max-height: 100%;
  min-height: 100%;
  pointer-events: auto;
  z-index: 4;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
  background-size: 500%;
  background-position: 100%;
  text-transform: capitalize;
  letter-spacing: 2px;
  transform-origin: center;
}
.smartPlan :host .button .button-icon {
  stroke: var(--text-color);
  fill: var(--text-color);
  height: 6vw;
  width: 6vw;
  margin: 1vw;
}

.btnAccount:host {
  width: 90vw;
  transform: rotate3d(1, 0, 0, 0deg) scaleX(0.975) scaleY(0.98);
}
.btnAccount:host.is-hovered {
  transform: rotate3d(1, 0, 0, -15deg) scaleX(1) scaleY(1);
}
.btnAccount:host .button {
  width: 100%;
  height: 4vh;
  background: linear-gradient(-75deg, hsla(var(--drop-color-primary)/0.3), hsla(var(--drop-color-secondary)/0.5), hsla(var(--drop-color-primary)/0.3));
}

.btnAccount2:host {
  width: 90vw;
  transform: rotate3d(1, 0, 0, 0deg) scaleX(0.975) scaleY(0.98);
}
.btnAccount2:host.is-hovered {
  transform: rotate3d(1, 0, 0, -15deg) scaleX(1) scaleY(1);
}
.btnAccount2:host .button {
  width: 100%;
  height: 4vh;
  background: linear-gradient(-75deg, hsla(var(--button-color)/0.05), hsla(var(--button-color)/0.15), hsla(var(--button-color)/0.05));
}
.btnAccount2:host .button .inData {
  color: hsla(var(--button-color)/0.5);
}

.addressAction:host {
  width: 80vw;
  min-height: 4vh;
}
.addressAction:host .button {
  width: 100%;
  height: 4vh;
}

.addressActionNew:host {
  width: 25vw;
  min-height: 6vw;
}
.addressActionNew:host .button {
  width: 100%;
  height: 6vw;
}

.footerToolbar .footerBtn:host {
  width: 100%;
  max-width: 75vw;
}
.footerToolbar .footerBtn:host .button {
  width: 100%;
}
.footerToolbar .footerBtn:host .inData {
  width: 100%;
  color: var(--ion-text-secondary);
}
.footerToolbar .disableBtn:host {
  pointer-events: none;
  width: 100%;
  max-width: 75vw;
}
.footerToolbar .disableBtn:host .button {
  pointer-events: none;
  width: 100%;
}
.footerToolbar .disableBtn:host .inData {
  pointer-events: none;
  width: 100%;
}

.btnBig:host,
.btnFull:host,
.btnSmall:host {
  box-shadow: var(--shadow-m);
}

.btnFull:host {
  width: 80vw;
}
.btnFull:host .button {
  width: 100%;
  height: 5vh;
}

.btnSmall:host {
  min-width: 25%;
}
.btnSmall:host .button {
  min-width: 100%;
  height: 5vh;
}

.btnBig:host {
  min-width: 70%;
}
.btnBig:host .button {
  min-width: 100%;
  height: 5vh;
}

.langBtn:host {
  min-width: 45vw;
}
.langBtn:host .button {
  min-width: 100%;
  height: 5vh;
}

.days:host {
  min-width: 20%;
  max-width: 21vw;
}
.days:host .button {
  min-width: 100%;
}
.days:host .button .inData {
  letter-spacing: 0px;
  flex-direction: row;
}
.days:host .button .inData .tag {
  font-size: 10px;
  margin: 3px;
  text-transform: capitalize;
}

.selDay:host .button .inData {
  font-weight: 600 !important;
  flex-direction: row;
  text-shadow: 0em 0.15em 0.05em rgba(255, 255, 255, 0.1);
  justify-content: center;
}
.selDay:host .button .inData .tag {
  font-size: 10px;
  text-transform: capitalize;
  font-weight: 400 !important;
  margin: 4px;
  text-shadow: 0em 0.15em 0.05em rgba(255, 255, 255, 0.1);
}

.smartAI:host {
  max-width: 5vh;
}
.smartAI:host .button {
  min-width: 5vh;
  height: 5vh;
  width: 100%;
}
.smartAI:host .button .inData {
  border-radius: 50%;
}

.deliveryManage:host {
  pointer-events: all;
}
.deliveryManage:host .button {
  width: 100%;
  height: 5vh;
  pointer-events: all;
  background: linear-gradient(-75deg, hsla(var(--button-color)/0.5), hsla(var(--button-color)/0.75), hsla(var(--button-color)/0.5));
}
.deliveryManage:host .button .inData {
  display: flex;
  flex-direction: column;
  pointer-events: all;
  color: var(--text-color);
}
.deliveryManage:host .button .inData .item {
  color: var(--text-color);
}

.rowBtn:host {
  pointer-events: all;
}
.rowBtn:host .button {
  width: 100%;
  height: 4vh;
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.rowBtn:host .button .inData {
  display: flex;
  flex-direction: row;
  pointer-events: all;
  color: var(--text-color);
  padding: 0vw 2vw;
}

.shortcutBtn:host {
  pointer-events: all;
  width: 5vh;
  height: 5vh;
  max-width: 5vh;
  max-height: 5vh;
  min-width: 5vh;
  min-height: 5vh;
}
.shortcutBtn:host .button {
  width: 5vh;
  height: 5vh;
  max-width: 5vh;
  max-height: 5vh;
  min-width: 5vh;
  min-height: 5vh;
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.shortcutBtn:host .button .inData {
  display: flex;
  flex-direction: row;
  pointer-events: all;
  color: var(--text-color);
  max-width: 5vh;
  max-height: 5vh;
  padding: 0;
}

.sliderHandle:host {
  pointer-events: all;
  width: 2.5vh;
  height: 2.5vh;
  min-width: 2.5vh;
  min-height: 2.5vh;
  max-width: 2.5vh;
  max-height: 2.5vh;
}
.sliderHandle:host .button {
  width: 2.5vh;
  height: 2.5vh;
  min-width: 2.5vh;
  min-height: 2.5vh;
  max-width: 2.5vh;
  max-height: 2.5vh;
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.sliderHandle:host .button .inData {
  display: flex;
  flex-direction: row;
  pointer-events: all;
  color: var(--text-color);
  min-width: 2.5vh;
  min-height: 2.5vh;
  max-width: 2.5vh;
  max-height: 2.5vh;
  padding: 0;
}

.menuMacroBig:host {
  pointer-events: all;
}
.menuMacroBig:host .button {
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.menuMacroBig:host .button .inData {
  display: flex;
  flex-direction: column;
  pointer-events: all;
  color: var(--text-color);
  padding: 0vw 4vw;
}
.menuMacroBig:host .button .inData .item {
  color: var(--text-color);
}

.macroValBig:host {
  pointer-events: all;
  min-height: 2vh;
  max-height: 2vh;
}
.macroValBig:host .button {
  min-height: 2vh;
  max-height: 2vh;
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.macroValBig:host .button .inData {
  display: flex;
  flex-direction: column;
  pointer-events: all;
  color: var(--text-color);
  padding: 0vw 3vw;
}
.macroValBig:host .button .inData .item {
  color: var(--text-color);
}

.journeyBtn:host {
  pointer-events: all;
}
.journeyBtn:host .button {
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.journeyBtn:host .button .inData {
  display: flex;
  flex-direction: row;
  pointer-events: all;
  color: var(--text-color);
  padding: 2vw;
  gap: 2vw;
  justify-content: flex-start;
}

.innerBtn:host {
  pointer-events: all;
  height: var(--height);
  min-height: var(--height);
  max-height: var(--height);
}
.innerBtn:host .button {
  height: var(--height);
  min-height: var(--height);
  max-height: var(--height);
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.innerBtn:host .button .inData {
  display: flex;
  gap: 2vw;
  flex-direction: column;
  pointer-events: all;
  color: var(--text-color);
  justify-content: center;
  align-items: center;
}

.statBtn:host {
  pointer-events: all;
}
.statBtn:host .button {
  pointer-events: all;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
}
.statBtn:host .button .inData {
  display: flex;
  flex-direction: column;
  pointer-events: all;
  color: var(--text-color);
  padding: 0vw;
}
.statBtn:host .button .inData .item {
  color: var(--text-color);
}

:host {
  --border-radii: var(--border-round);
  --global--size: clamp(2rem, 3em, 5rem);
  --anim--hover-time: 0.25s;
  --anim--hover-ease: cubic-bezier(1, 1.9, 0.25, 1.9);
  --angle-1: -75deg;
  --angle-2: 0deg;
  min-height: var(--height);
  width: var(--width);
  display: flex;
  position: relative;
  z-index: 2;
  border-radius: var(--border-radii);
  background: transparent;
  pointer-events: none;
  transition: all var(--anim--hover-time) var(--anim--hover-ease);
  overflow: hidden;
  transform: rotate3d(1, 0, 0, 0deg) scaleX(1) scaleY(0.975);
  box-shadow: var(--shadow-side-anim), inset -0.5px 0.5px 15px -5px hsl(var(--drop-light-white)/0.25), inset 1px -1px 15px -5px hsl(var(--drop-bright-white)/0.25), inset -2px 2px 15px -5px hsl(var(--drop-fade-white)/0.5), 0 0 0.5px 1px inset rgba(255, 255, 255, 0.5), 0 0 0 0 rgb(255, 255, 255);
}
:host.is-hovered {
  transform: rotate3d(1, 0, 0, 0deg) scaleX(0.925) scaleY(1);
  box-shadow: var(--shadow-glass-anim), inset -0.5px 0.5px 15px -5px hsl(var(--drop-light-white)/0.25), inset 1px -1px 15px -5px hsl(var(--drop-bright-white)/0.25), inset -2px 2px 15px -5px hsl(var(--drop-fade-white)/0.5), 0 0 0.5px 1px inset rgba(255, 255, 255, 0.5), 0 0 0 0 rgb(255, 255, 255);
}

.button {
  cursor: pointer;
  display: flex;
  flex: 1;
  position: relative;
  pointer-events: auto;
  z-index: 3;
  background: linear-gradient(-75deg, var(--clear-color), var(--clear2-color), var(--clear3-color));
  border-radius: var(--border-radii);
  overflow: hidden;
  transition: all var(--anim--hover-time) var(--anim--hover-ease);
}

:host(.is-hovered) .button {
  backdrop-filter: blur(0.01em);
  -webkit-backdrop-filter: blur(0.01em);
  -moz-backdrop-filter: blur(0.01em);
  -ms-backdrop-filter: blur(0.01em);
}

.inData {
  background-image: linear-gradient(hsla(0, 0%, 0%, 0.2), hsla(0, 0%, 0%, 0));
  position: relative;
  display: flex;
  flex: 1;
  border-radius: var(--border-radii);
  align-items: center;
  justify-content: space-evenly;
  flex-direction: row-reverse;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  letter-spacing: 1px;
  font-size: 1em;
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all var(--anim--hover-time) var(--anim--hover-ease);
  padding: 0vw;
  min-height: 100%;
  box-shadow: 0 -0.125em 0.25em hsla(0, 0%, 0%, 0.2), 0 0.25em 0.25em hsla(var(--ion-glass-secondary), var(--ion-glow-secondary), var(--ion-satur-secondary), 0.25), 0 0 0 0.25em hsla(var(--ion-glass-secondary), var(--ion-glow-secondary), var(--ion-satur-secondary), 0.25), 0 0.375em 0.5em hsla(var(--ion-glass-secondary), var(--ion-glow-secondary), var(--ion-satur-secondary), 0.25) inset, 0 -0.125em 0.375em hsla(var(--ion-glass-secondary), var(--ion-glow-secondary), var(--ion-satur-secondary), 0.14) inset, 0 -1.25em 2em 0.5em hsla(var(--ion-glass-secondary), var(--ion-glow-secondary), var(--ion-satur-secondary), 0.13) inset, 0 1.25em 0.5em 0em hsla(var(--ion-glass-secondary), var(--ion-glow-secondary), var(--ion-satur-secondary), 0.13) inset, 0 5em 3em hsla(0, 0%, 0%, 0.4);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  -moz-backdrop-filter: blur(12px);
  -ms-backdrop-filter: blur(12px);
  overflow: hidden;
}

.inData::before {
  background: radial-gradient(100% 100% at center, hsla(var(--ion-glass-secondary), var(--ion-glow-secondary), 80%, 0.25), hsla(var(--ion-glass-secondary), var(--ion-glow-secondary), 80%, 0) 50%);
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0%;
  width: 100%;
  height: 100%;
  transform: translateX(0%);
  overflow: hidden;
}

.disabledBtn {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-button/app-button.component.scss"],"names":[],"mappings":"AAAA,8FAAA;AAIA;EACE,kCAAA;AAFF;;AAKA;EACE,kCAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,wBAAA;EACA,kBAAA;AAFF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAHF;;AAOA;EACE,eAAA;EACA,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAJF;AAOE;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mDAAA;AALJ;;AASA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AANF;AAQE;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AANJ;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EAGA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EAEA,gCAAA;EACA,gBAAA;AAXF;;AAeA;EACE,6BAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;AAZF;;AAeA;EACE,6BAAA;EACA,YAAA;EAGA,YAAA;EACA,WAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,6BAAA;EACA,YAAA;EAGA,WAAA;EACA,WAAA;EACA,iBAAA;AAhBF;;AAqBA;EACE,mBAAA;EAEA,WAAA;EAEA,eAAA;EAEA,eAAA;EACA,gBAAA;AArBF;AAuBE;EAEE,WAAA;EAEA,eAAA;EAEA,eAAA;EACA,mBAAA;EAOA,iGAAA;AA9BJ;AAmCI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EAEA,eAAA;EACA,UAAA;AAlCN;;AA6CI;EACE,YAAA;AA1CN;;AAqDI;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,mBAAA;EACA,6BAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EACA,+DAAA;EACA,MAAA;EACA,gBAAA;AAlDN;;AA6DI;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EACA,+DAAA;EACA,gBAAA;EACA,MAAA;AA1DN;;AAsEI;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EACA,+DAAA;EACA,YAAA;EACA,gBAAA;AAnEN;;AA6EI;EAEE,cAAA;AA3EN;AA+EM;EACE,gBAAA;AA7ER;AAgFM;EACE,WAAA;EACA,UAAA;AA9ER;;AAoFA;EACE,mBAAA;EAEA,WAAA;EAEA,eAAA;EAEA,eAAA;AApFF;AAsFE;EACE,mBAAA;EAEA,WAAA;EAEA,eAAA;EAEA,eAAA;AAvFJ;AAyFI;EAEE,WAAA;EAEA,eAAA;EAEA,eAAA;EACA,mBAAA;EAOA,iGAAA;AAhGN;AAqGM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EAEA,eAAA;EACA,gBAAA;EACA,QAAA;AApGR;AAuGQ;EACE,yBAAA;EACA,UAAA;AArGV;AAwGQ;EACE,wBAAA;AAtGV;;AA+GI;EAEE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EAWA,yCAAA;AAvHN;AA8GM;EACE,gBAAA;AA5GR;AA+GM;EAEE,QAAA;AA9GR;AAmHM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAjHR;;AAuHA;EACE,mBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AApHF;AAsHE;EACE,mBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AApHJ;AAsHI;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EAOA,iGAAA;AA1HN;AA+HM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AA7HR;AA+HQ;EACE,yBAAA;EACA,UAAA;AA7HV;AAgIQ;EACE,wBAAA;AA9HV;;AAsIE;EACE,gBAAA;AAnIJ;AAqII;EAEE,0BAAA;EACA,UAAA;EACA,gBAAA;AApIN;AAsIM;EACE,gBAAA;AApIR;AAuIM;EACE,QAAA;AArIR;AAwIM;EACE,WAAA;EACA,UAAA;AAtIR;;AA4IA;EACE,uCAAA;AAzIF;AA2IE;EACE,eAAA;EACA,mBAAA;EACA,eAAA;AAzIJ;;AA+II;EAEE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AA7IN;AA+IM;EACE,gBAAA;AA7IR;AAiJI;EACE,WAAA;EACA,UAAA;EACA,WAAA;AA/IN;AAkJI;EACE,aAAA;AAhJN;;AAuJI;EAGE,WAAA;EACA,gBAAA;EACA,gBAAA;EAEA,oBAAA;EACA,UAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EAEA,qBAAA;EACA,yBAAA;EAEA,0BAAA;EACA,mBAAA;EACA,wBAAA;AAzJN;AA2JM;EACE,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAzJR;;AAmKA;EACE,WAAA;EACA,6DAAA;AAhKF;AAkKE;EACE,wDAAA;AAhKJ;AAmKE;EACE,WAAA;EACA,WAAA;EAQA,oJAAA;AAxKJ;;AA4KA;EACE,WAAA;EACA,6DAAA;AAzKF;AA2KE;EACE,wDAAA;AAzKJ;AA4KE;EACE,WAAA;EACA,WAAA;EAEA,mIAAA;AA3KJ;AAgLI;EACE,oCAAA;AA9KN;;AAqLA;EACE,WAAA;EACA,eAAA;AAlLF;AAoLE;EACE,WAAA;EACA,WAAA;AAlLJ;;AAsLA;EACE,WAAA;EACA,eAAA;AAnLF;AAqLE;EACE,WAAA;EACA,WAAA;AAnLJ;;AAwLE;EACE,WAAA;EACA,eAAA;AArLJ;AAuLI;EACE,WAAA;AArLN;AAwLI;EACE,WAAA;EACA,gCAAA;AAtLN;AA0LE;EACE,oBAAA;EACA,WAAA;EACA,eAAA;AAxLJ;AA0LI;EACE,oBAAA;EACA,WAAA;AAxLN;AA2LI;EACE,oBAAA;EACA,WAAA;AAzLN;;AA8LA;;;EAGE,2BAAA;AA3LF;;AA8LA;EACE,WAAA;AA3LF;AA6LE;EACE,WAAA;EACA,WAAA;AA3LJ;;AAiMA;EACE,cAAA;AA9LF;AAgME;EACE,eAAA;EACA,WAAA;AA9LJ;;AAoMA;EACE,cAAA;AAjMF;AAmME;EACE,eAAA;EACA,WAAA;AAjMJ;;AAuMA;EACE,eAAA;AApMF;AAsME;EACE,eAAA;EACA,WAAA;AApMJ;;AA2MA;EACE,cAAA;EAEA,eAAA;AAzMF;AA2ME;EACE,eAAA;AAzMJ;AA4MI;EACE,mBAAA;EACA,mBAAA;AA1MN;AA4MM;EACE,eAAA;EACA,WAAA;EACA,0BAAA;AA1MR;;AAwNI;EACE,2BAAA;EACA,mBAAA;EACA,uDAAA;EACA,uBAAA;AArNN;AAuNM;EACE,eAAA;EACA,0BAAA;EACA,2BAAA;EACA,WAAA;EACA,uDAAA;AArNR;;AA2NA;EACE,cAAA;AAxNF;AA0NE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AAxNJ;AA0NI;EAEE,kBAAA;AAzNN;;AA8NA;EACE,mBAAA;AA3NF;AA6NE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,iIAAA;AA3NJ;AAgOI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;AA9NN;AAgOM;EACE,wBAAA;AA9NR;;AAoOA;EACE,mBAAA;AAjOF;AAmOE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EAOA,iGAAA;AAvOJ;AA4OI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;AA1ON;;AA+OA;EACE,mBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA5OF;AA8OE;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EAOA,iGAAA;AAlPJ;AAuPI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AArPN;;AA2PA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAxPF;AA0PE;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EAOA,iGAAA;AA9PJ;AAmQI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AAjQN;;AAuQA;EACE,mBAAA;AApQF;AAsQE;EAEE,mBAAA;EAOA,iGAAA;AA3QJ;AAgRI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;AA9QN;AAiRM;EACE,wBAAA;AA/QR;;AAqRA;EACE,mBAAA;EACA,eAAA;EACA,eAAA;AAlRF;AAoRE;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EAOA,iGAAA;AAxRJ;AA6RI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;AA3RN;AA8RM;EACE,wBAAA;AA5RR;;AAkSA;EACE,mBAAA;AA/RF;AAiSE;EACE,mBAAA;EACA,iGAAA;AA/RJ;AAoSI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,QAAA;EAEA,2BAAA;AAnSN;;AAwSA;EACE,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AArSF;AAuSE;EACE,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iGAAA;AArSJ;AA0SI;EACE,aAAA;EACA,QAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EAEA,uBAAA;EACA,mBAAA;AAzSN;;AAgTA;EACE,mBAAA;AA7SF;AAiTE;EAGE,mBAAA;EAOA,iGAAA;AAvTJ;AA4TI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;AA1TN;AA6TM;EACE,wBAAA;AA3TR;;AAkUA;EACE,mCAAA;EACA,sCAAA;EACA,yBAAA;EACA,mDAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,kCAAA;EACA,uBAAA;EACA,oBAAA;EACA,+DAAA;EACA,gBAAA;EAMA,0DAAA;EACA,oSAAA;AApUF;AAsUE;EACE,0DAAA;EAEA,qSAAA;AArUJ;;AA+UA;EACE,eAAA;EACA,aAAA;EACA,OAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,iGAAA;EAIA,kCAAA;EACA,gBAAA;EAKA,+DAAA;AAnVF;;AAwVA;EAEE,6BAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;AAtVF;;AA0VA;EACI,2EAAA;EAGF,kBAAA;EACA,aAAA;EACA,OAAA;EACA,kCAAA;EACA,mBAAA;EACA,6BAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EAEA,+DAAA;EACA,YAAA;EACA,gBAAA;EACA,2wBACA;EASA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,gBAAA;AAnWF;;AAqWA;EACG,iMAAA;EACF,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACC,gBAAA;AAlWF;;AAoWA;EACE,YAAA;AAjWF","sourcesContent":["/* --- Context-specific styles (Your original Host-based styles, with updated selectors) --- */\n// These will continue to override specific properties based on parent context\n// Adjust padding on .button-glass if you need to change spacing for specific variants.\n\n:host {\n  border-radius: var(--border-radii);\n}\n\n:host ::ng-deep .foodTypeLabel2 {\n  border-radius: var(--border-radii);\n}\n\n:host ::ng-deep .button {\n  min-height: 100%;\n}\n\n:host ::ng-deep .inText {\n  color: var(--text-color);\n  text-align: center;\n  // transition: all var(--anim--hover-time) var(--anim--hover-ease);\n}\n\n:host ::ng-deep .inData {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.metaBox:host ::ng-deep .inData {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: 0 1vw;\n  font-size: 12px;\n}\n\n.loyaltyContainer:host ::ng-deep .inData {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: 0 1vw;\n  // font-size: 12px;\n}\n\n.manual-move-btn:host ::ng-deep .inData {\n  font-size: 12px;\n  padding: 0 1vh;\n}\n\n.rowContent:host ::ng-deep .inData {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 2vw;\n  width: 100%;\n\n\n  .inText {\n    height: calc(100% - 28vw);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    transition: all var(--anim--hover-time) ease-in-out;\n  }\n}\n\n.colContent:host ::ng-deep .inData {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2vw;\n  width: 100%;\n\n  .inText {\n    height: calc(100% - 24vw);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0vw 0 2vw 0;\n  }\n}\n\n\n:host ::ng-deep .inData {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2vw;\n  width: 100%;\n\n  // .inText {\n  position: relative;\n  display: flex;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  letter-spacing: 1px;\n  font-weight: 500;\n  font-size: 18px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  transition: all 0.3s ease-in-out;\n  padding: 1vw 2vw;\n  // }\n}\n\n:host ::ng-deep .inIcon {\n  background-color: transparent;\n  border: none;\n  stroke: var(--text-color);\n  fill: var(--text-color);\n  height: 4vh;\n  width: 4vh;\n}\n\n:host ::ng-deep .inImg {\n  background-color: transparent;\n  border: none;\n  // stroke: var(--text-color);\n  // fill: var(--text-color);\n  height: 24vw;\n  width: 24vw;\n  object-fit: fill;\n}\n\n:host ::ng-deep .conImg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: transparent;\n  border: none;\n  // stroke: var(--text-color);\n  // fill: var(--text-color);\n  height: 7vh;\n  width: 100%;\n  object-fit: cover;\n}\n\n\n\n.foodTypeLabel:host {\n  pointer-events: all;\n  // width: 5vh;\n  height: 3vh;\n  // max-width: 5vh;\n  max-height: 3vh;\n  // min-width: 5vh;\n  min-height: 3vh;\n  box-shadow: none;\n\n  .button {\n    // width: 5vh;\n    height: 3vh;\n    // max-width: 5vh;\n    max-height: 3vh;\n    // min-width: 5vh;\n    min-height: 3vh;\n    pointer-events: all;\n    //    background: linear-gradient(\n    //   -75deg,\n    //   hsla(var(--button-color)/0.5),\n    //   hsla(var(--button-color)/0.75),\n    //   hsla(var(--button-color)/0.5)\n    // );\n    background: linear-gradient(-75deg,\n        var(--clear-color),\n        var(--clear2-color),\n        var(--clear3-color));\n\n    .inData {\n      display: flex;\n      flex-direction: row;\n      pointer-events: all;\n      color: var(--text-color);\n      // max-width: 5vh;\n      max-height: 3vh;\n      padding: 0;\n    }\n  }\n}\n\n.doubleBtn:host {\n  // --border-round: 15px 15px 0 0 !important;\n\n  .button {\n\n    // height: 100%;\n    .inData {\n      padding: 1vw;\n    }\n  }\n}\n\n.box1:host {\n  // --border-round: 15px 15px 0 0 !important;\n\n  .button {\n\n    // height: 100%;\n    .inData {\n      position: relative;\n      display: flex;\n      flex: 1;\n      align-items: center;\n      justify-content: space-evenly;\n      flex-direction: row-reverse;\n      user-select: none;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      letter-spacing: 1px;\n      font-size: 14px;\n      color: var(--text-color);\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      transition: all var(--anim--hover-time) var(--anim--hover-ease);\n      gap: 0;\n      min-height: 100%;\n    }\n  }\n}\n\n.box2:host {\n  // --border-round: 15px 15px 0 0 !important;\n\n  .button {\n\n    // height: 100%;\n    .inData {\n      position: relative;\n      display: flex;\n      flex: 1;\n      align-items: center;\n      justify-content: space-evenly;\n      flex-direction: row;\n      user-select: none;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      letter-spacing: 1px;\n      font-size: 14px;\n      color: var(--text-color);\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      transition: all var(--anim--hover-time) var(--anim--hover-ease);\n      min-height: 100%;\n      gap: 0;\n\n    }\n  }\n}\n\n.removeDB:host {\n  // --border-round: 15px 15px 0 0 !important;\n\n  .button {\n\n    // height: 100%;\n    .inData {\n      position: relative;\n      display: flex;\n      flex: 1;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n      user-select: none;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      letter-spacing: 1px;\n      font-size: 14px;\n      color: var(--text-color);\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      transition: all var(--anim--hover-time) var(--anim--hover-ease);\n      padding: 0vw;\n      min-height: 100%;\n\n\n\n    }\n  }\n}\n\n.modalFooter {\n  :host {\n    .button {\n      // Target the main .button container\n      min-width: 8vw;\n      // min-height: auto; // Allow height to be determined by content or parent\n      // padding: 0; // Reset base padding to 0, if variant defines its own inner padding\n\n      .button-glass {\n        padding: 1vw 2vw; // Re-apply default padding here, or define variant specific\n      }\n\n      .button-icon {\n        height: 6vw;\n        width: 6vw;\n      }\n    }\n  }\n}\n\n.action-button {\n  pointer-events: all;\n  // width: 3vh;\n  height: 3vh;\n  // max-width: 3vh;\n  max-height: 3vh;\n  // min-width: 3vh;\n  min-height: 3vh;\n\n  :host {\n    pointer-events: all;\n    // width: 3vh;\n    height: 3vh;\n    // max-width: 3vh;\n    max-height: 3vh;\n    // min-width: 3vh;\n    min-height: 3vh;\n\n    .button {\n      // width: 3vh;\n      height: 3vh;\n      // max-width: 3vh;\n      max-height: 3vh;\n      // min-width: 3vh;\n      min-height: 3vh;\n      pointer-events: all;\n      //    background: linear-gradient(\n      //   -75deg,\n      //   hsla(var(--button-color)/0.5),\n      //   hsla(var(--button-color)/0.75),\n      //   hsla(var(--button-color)/0.5)\n      // );\n      background: linear-gradient(-75deg,\n          var(--clear-color),\n          var(--clear2-color),\n          var(--clear3-color));\n\n      .inData {\n        display: flex;\n        flex-direction: row;\n        pointer-events: all;\n        color: var(--text-color);\n        // max-width: 3vh;\n        max-height: 3vh;\n        padding: 0vh 1vh;\n        gap: 1vh;\n\n        // padding: 0;\n        .shotcutIcon {\n          stroke: var(--text-color);\n          fill: none;\n        }\n\n        .item {\n          color: var(--text-color);\n        }\n      }\n    }\n  }\n}\n\n.delete-button {\n  :host {\n    .button {\n      // Target the main .button container\n      min-width: 7vw;\n      border-radius: 15px;\n      height: 6vw;\n      min-height: auto;\n      padding: 0;\n\n      .button-glass {\n        padding: 1vw 2vw; // Example: maintain default padding\n      }\n\n      .button-content {\n        // Target the content flex container\n        gap: 0vw;\n      }\n\n      border: 1px solid var(--ion-color-danger); // This border applies to the .button container\n\n      .button-icon {\n        height: 5vw;\n        width: 5vw;\n        margin: 0;\n        padding: 0;\n      }\n    }\n  }\n}\n\n.delete-button {\n  pointer-events: all;\n  width: 3vh;\n  height: 3vh;\n  max-width: 3vh;\n  max-height: 3vh;\n  min-width: 3vh;\n  min-height: 3vh;\n\n  :host {\n    pointer-events: all;\n    width: 3vh;\n    height: 3vh;\n    max-width: 3vh;\n    max-height: 3vh;\n    min-width: 3vh;\n    min-height: 3vh;\n\n    .button {\n      width: 3vh;\n      height: 3vh;\n      max-width: 3vh;\n      max-height: 3vh;\n      min-width: 3vh;\n      min-height: 3vh;\n      pointer-events: all;\n      //    background: linear-gradient(\n      //   -75deg,\n      //   hsla(var(--button-color)/0.5),\n      //   hsla(var(--button-color)/0.75),\n      //   hsla(var(--button-color)/0.5)\n      // );\n      background: linear-gradient(-75deg,\n          var(--clear-color),\n          var(--clear2-color),\n          var(--clear3-color));\n\n      .inData {\n        display: flex;\n        flex-direction: row;\n        pointer-events: all;\n        color: var(--text-color);\n        max-width: 3vh;\n        max-height: 3vh;\n        padding: 0.5vh;\n\n        .shotcutIcon {\n          stroke: var(--text-color);\n          fill: none;\n        }\n\n        .item {\n          color: var(--text-color);\n        }\n      }\n    }\n  }\n}\n\n.header {\n  :host {\n    background: none;\n\n    .button {\n      // Target the main .button container\n      font-size: 12px !important;\n      padding: 0;\n      min-height: auto;\n\n      .button-glass {\n        padding: 1vw 4vw; // Re-apply specific padding for this variant\n      }\n\n      .button-content {\n        gap: 2vw;\n      }\n\n      .button-icon {\n        height: 4vw;\n        width: 4vw;\n      }\n    }\n  }\n}\n\n.newPost:host {\n  box-shadow: var(--shadow-side-anim-end);\n\n  .label {\n    margin: 1vw 2vw;\n    letter-spacing: 2px;\n    font-size: 14px;\n  }\n}\n\n.form-footer {\n  :host {\n    .button {\n      // Target the main .button container\n      border-radius: 20px;\n      overflow: hidden;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      height: 4vh;\n      min-height: auto;\n      padding: 0;\n\n      .button-glass {\n        padding: 1vw 2vw; // Re-apply padding\n      }\n    }\n\n    .button-icon {\n      height: 3vh;\n      width: 4vh;\n      margin: 1vw;\n    }\n\n    .label {\n      margin: 0 2vw;\n    }\n  }\n}\n\n.smartPlan {\n  :host {\n    .button {\n      // Target the main .button container\n      // font-size: 12px !important;\n      height: 5vh;\n      max-height: 100%;\n      min-height: 100%;\n      // border-radius: 10px;\n      pointer-events: auto;\n      z-index: 4;\n      display: flex;\n      flex-direction: row-reverse;\n      align-items: center;\n      justify-content: center;\n      padding: 0;\n      position: relative;\n      // color: var(--button-Tcolor);\n      background-size: 500%;\n      background-position: 100%;\n      // font-weight: 400;\n      text-transform: capitalize;\n      letter-spacing: 2px;\n      transform-origin: center;\n\n      .button-icon {\n        stroke: var(--text-color);\n        fill: var(--text-color);\n        height: 6vw;\n        width: 6vw;\n        margin: 1vw;\n      }\n\n      // .button-glass {\n      //   padding: 0 1vh; // Re-apply specific padding\n      // }\n    }\n  }\n}\n\n.btnAccount:host {\n  width: 90vw;\n  transform: rotate3d(1, 0, 0, 0deg) scaleX(0.975) scaleY(0.98);\n\n  &.is-hovered {\n    transform: rotate3d(1, 0, 0, -15deg) scaleX(1) scaleY(1);\n  }\n\n  .button {\n    width: 100%;\n    height: 4vh;\n\n    //    background: linear-gradient(\n    //   -75deg,\n    //   hsla(var(--button-color)/0.05),\n    //   hsla(var(--button-color)/0.15),\n    //   hsla(var(--button-color)/0.05)\n    // );\n    background: linear-gradient(-75deg, hsla(var(--drop-color-primary) / 0.3), hsla(var(--drop-color-secondary) / 0.5), hsla(var(--drop-color-primary) / 0.3));\n  }\n}\n\n.btnAccount2:host {\n  width: 90vw;\n  transform: rotate3d(1, 0, 0, 0deg) scaleX(0.975) scaleY(0.98);\n\n  &.is-hovered {\n    transform: rotate3d(1, 0, 0, -15deg) scaleX(1) scaleY(1);\n  }\n\n  .button {\n    width: 100%;\n    height: 4vh;\n\n    background: linear-gradient(-75deg,\n        hsla(var(--button-color)/0.05),\n        hsla(var(--button-color)/0.15),\n        hsla(var(--button-color)/0.05));\n\n    .inData {\n      color: hsla(var(--button-color)/0.5);\n    }\n\n    // background: linear-gradient(-75deg, hsla(var(--drop-color-primary) / 0.3), hsla(var(--drop-color-secondary) / 0.5), hsla(var(--drop-color-primary) / 0.3));\n  }\n}\n\n.addressAction:host {\n  width: 80vw;\n  min-height: 4vh;\n\n  .button {\n    width: 100%;\n    height: 4vh;\n  }\n}\n\n.addressActionNew:host {\n  width: 25vw;\n  min-height: 6vw;\n\n  .button {\n    width: 100%;\n    height: 6vw;\n  }\n}\n\n.footerToolbar {\n  .footerBtn:host {\n    width: 100%;\n    max-width: 75vw;\n\n    .button {\n      width: 100%;\n    }\n\n    .inData {\n      width: 100%;\n      color: var(--ion-text-secondary);\n    }\n  }\n\n  .disableBtn:host {\n    pointer-events: none;\n    width: 100%;\n    max-width: 75vw;\n\n    .button {\n      pointer-events: none;\n      width: 100%;\n    }\n\n    .inData {\n      pointer-events: none;\n      width: 100%;\n    }\n  }\n}\n\n.btnBig:host,\n.btnFull:host,\n.btnSmall:host {\n  box-shadow: var(--shadow-m); // This applies to the host itself\n}\n\n.btnFull:host {\n  width: 80vw;\n\n  .button {\n    width: 100%;\n    height: 5vh;\n    // padding: 0 2vh;\n    // font-weight: 700;\n  }\n}\n\n.btnSmall:host {\n  min-width: 25%;\n\n  .button {\n    min-width: 100%;\n    height: 5vh;\n    // padding: 0 2vh;\n    // font-weight: 700;\n  }\n}\n\n.btnBig:host {\n  min-width: 70%;\n\n  .button {\n    min-width: 100%;\n    height: 5vh;\n    // padding: 0 2vh;\n    // font-weight: 700;\n  }\n}\n\n.langBtn:host {\n  min-width: 45vw;\n\n  .button {\n    min-width: 100%;\n    height: 5vh;\n    // padding: 0 2vh;\n    // font-weight: 700;\n  }\n}\n\n\n.days:host {\n  min-width: 20%;\n  // height: 4vh;\n  max-width: 21vw;\n\n  .button {\n    min-width: 100%;\n    // height: 4vh;\n\n    .inData {\n      letter-spacing: 0px;\n      flex-direction: row;\n\n      .tag {\n        font-size: 10px;\n        margin: 3px;\n        text-transform: capitalize;\n\n      }\n\n      // color: var(--ion-color-white);\n    }\n\n    // padding: 0 2vh;\n    // font-weight: 700;\n  }\n}\n\n.selDay:host {\n  .button {\n    .inData {\n      font-weight: 600 !important;\n      flex-direction: row;\n      text-shadow: 0em 0.15em 0.05em rgba(255, 255, 255, 0.1);\n      justify-content: center;\n\n      .tag {\n        font-size: 10px;\n        text-transform: capitalize;\n        font-weight: 400 !important;\n        margin: 4px;\n        text-shadow: 0em 0.15em 0.05em rgba(255, 255, 255, 0.1);\n      }\n    }\n  }\n}\n\n.smartAI:host {\n  max-width: 5vh;\n\n  .button {\n    min-width: 5vh;\n    height: 5vh;\n    width: 100%;\n\n    .inData {\n      // padding: 0 !important;\n      border-radius: 50%;\n    }\n  }\n}\n\n.deliveryManage:host {\n  pointer-events: all;\n\n  .button {\n    width: 100%;\n    height: 5vh;\n    pointer-events: all;\n    background: linear-gradient(-75deg,\n        hsla(var(--button-color)/0.5),\n        hsla(var(--button-color)/0.75),\n        hsla(var(--button-color)/0.5));\n\n    .inData {\n      display: flex;\n      flex-direction: column;\n      pointer-events: all;\n      color: var(--text-color);\n\n      .item {\n        color: var(--text-color);\n      }\n    }\n  }\n}\n\n.rowBtn:host {\n  pointer-events: all;\n\n  .button {\n    width: 100%;\n    height: 4vh;\n    pointer-events: all;\n    //    background: linear-gradient(\n    //   -75deg,\n    //   hsla(var(--button-color)/0.5),\n    //   hsla(var(--button-color)/0.75),\n    //   hsla(var(--button-color)/0.5)\n    // );\n    background: linear-gradient(-75deg,\n        var(--clear-color),\n        var(--clear2-color),\n        var(--clear3-color));\n\n    .inData {\n      display: flex;\n      flex-direction: row;\n      pointer-events: all;\n      color: var(--text-color);\n      padding: 0vw 2vw;\n    }\n  }\n}\n\n.shortcutBtn:host {\n  pointer-events: all;\n  width: 5vh;\n  height: 5vh;\n  max-width: 5vh;\n  max-height: 5vh;\n  min-width: 5vh;\n  min-height: 5vh;\n\n  .button {\n    width: 5vh;\n    height: 5vh;\n    max-width: 5vh;\n    max-height: 5vh;\n    min-width: 5vh;\n    min-height: 5vh;\n    pointer-events: all;\n    //    background: linear-gradient(\n    //   -75deg,\n    //   hsla(var(--button-color)/0.5),\n    //   hsla(var(--button-color)/0.75),\n    //   hsla(var(--button-color)/0.5)\n    // );\n    background: linear-gradient(-75deg,\n        var(--clear-color),\n        var(--clear2-color),\n        var(--clear3-color));\n\n    .inData {\n      display: flex;\n      flex-direction: row;\n      pointer-events: all;\n      color: var(--text-color);\n      max-width: 5vh;\n      max-height: 5vh;\n      padding: 0;\n\n    }\n  }\n}\n\n.sliderHandle:host {\n  pointer-events: all;\n  width: 2.5vh;\n  height: 2.5vh;\n  min-width: 2.5vh;\n  min-height: 2.5vh;\n  max-width: 2.5vh;\n  max-height: 2.5vh;\n\n  .button {\n    width: 2.5vh;\n    height: 2.5vh;\n    min-width: 2.5vh;\n    min-height: 2.5vh;\n    max-width: 2.5vh;\n    max-height: 2.5vh;\n    pointer-events: all;\n    //    background: linear-gradient(\n    //   -75deg,\n    //   hsla(var(--button-color)/0.5),\n    //   hsla(var(--button-color)/0.75),\n    //   hsla(var(--button-color)/0.5)\n    // );\n    background: linear-gradient(-75deg,\n        var(--clear-color),\n        var(--clear2-color),\n        var(--clear3-color));\n\n    .inData {\n      display: flex;\n      flex-direction: row;\n      pointer-events: all;\n      color: var(--text-color);\n      min-width: 2.5vh;\n      min-height: 2.5vh;\n      max-width: 2.5vh;\n      max-height: 2.5vh;\n      padding: 0;\n\n    }\n  }\n}\n\n.menuMacroBig:host {\n  pointer-events: all;\n\n  .button {\n\n    pointer-events: all;\n    //    background: linear-gradient(\n    //   -75deg,\n    //   hsla(var(--button-color)/0.5),\n    //   hsla(var(--button-color)/0.75),\n    //   hsla(var(--button-color)/0.5)\n    // );\n    background: linear-gradient(-75deg,\n        var(--clear-color),\n        var(--clear2-color),\n        var(--clear3-color));\n\n    .inData {\n      display: flex;\n      flex-direction: column;\n      pointer-events: all;\n      color: var(--text-color);\n      padding: 0vw 4vw;\n\n\n      .item {\n        color: var(--text-color);\n      }\n    }\n  }\n}\n\n.macroValBig:host {\n  pointer-events: all;\n  min-height: 2vh;\n  max-height: 2vh;\n\n  .button {\n    min-height: 2vh;\n    max-height: 2vh;\n    pointer-events: all;\n    //    background: linear-gradient(\n    //   -75deg,\n    //   hsla(var(--button-color)/0.5),\n    //   hsla(var(--button-color)/0.75),\n    //   hsla(var(--button-color)/0.5)\n    // );\n    background: linear-gradient(-75deg,\n        var(--clear-color),\n        var(--clear2-color),\n        var(--clear3-color));\n\n    .inData {\n      display: flex;\n      flex-direction: column;\n      pointer-events: all;\n      color: var(--text-color);\n      padding: 0vw 3vw;\n\n\n      .item {\n        color: var(--text-color);\n      }\n    }\n  }\n}\n\n.journeyBtn:host {\n  pointer-events: all;\n\n  .button {\n    pointer-events: all;\n    background: linear-gradient(-75deg,\n        var(--clear-color),\n        var(--clear2-color),\n        var(--clear3-color));\n\n    .inData {\n      display: flex;\n      flex-direction: row;\n      pointer-events: all;\n      color: var(--text-color);\n      padding: 2vw;\n      gap: 2vw;\n\n      justify-content: flex-start;\n    }\n  }\n}\n\n.innerBtn:host {\n  pointer-events: all;\n  height: var(--height);\n  min-height: var(--height);\n  max-height: var(--height);\n\n  .button {\n    height: var(--height);\n    min-height: var(--height);\n    max-height: var(--height);\n    pointer-events: all;\n    background: linear-gradient(-75deg,\n        var(--clear-color),\n        var(--clear2-color),\n        var(--clear3-color));\n\n    .inData {\n      display: flex;\n      gap: 2vw;\n      flex-direction: column;\n      pointer-events: all;\n      color: var(--text-color);\n      // padding: 2vw;\n      justify-content: center;\n      align-items: center;\n\n\n    }\n  }\n}\n\n.statBtn:host {\n  pointer-events: all;\n  // min-height: 5vh;\n\n  // max-height: 5vh;\n  .button {\n    // min-height: 5vh;\n    // max-height: 5vh;\n    pointer-events: all;\n    //    background: linear-gradient(\n    //   -75deg,\n    //   hsla(var(--button-color)/0.5),\n    //   hsla(var(--button-color)/0.75),\n    //   hsla(var(--button-color)/0.5)\n    // );\n    background: linear-gradient(-75deg,\n        var(--clear-color),\n        var(--clear2-color),\n        var(--clear3-color));\n\n    .inData {\n      display: flex;\n      flex-direction: column;\n      pointer-events: all;\n      color: var(--text-color);\n      padding: 0vw;\n\n\n      .item {\n        color: var(--text-color);\n      }\n    }\n  }\n}\n\n//main styles\n:host {\n  --border-radii: var(--border-round);\n  --global--size: clamp(2rem, 3em, 5rem); // If used elsewhere in component\n  --anim--hover-time: 0.25s;\n  --anim--hover-ease: cubic-bezier(1, 1.9, 0.25, 1.9);\n  --angle-1: -75deg;\n  --angle-2: 0deg;\n  min-height: var(--height);\n  width: var(--width);\n  display: flex;\n  position: relative;\n  z-index: 2;\n  border-radius: var(--border-radii);\n  background: transparent;\n  pointer-events: none; // Default for the host, button will be auto\n  transition: all var(--anim--hover-time) var(--anim--hover-ease);\n  overflow: hidden;\n  // flex: 1;\n  // min-height: 4vh;\n  // min-width: 4vh;\n  // box-shadow: var(--shadow-side-anim);\n\n  transform: rotate3d(1, 0, 0, 0deg) scaleX(1) scaleY(0.975);\n  box-shadow: var(--shadow-side-anim), inset -0.5px 0.5px 15px -5px hsl(var(--drop-light-white) / 0.25), inset 1px -1px 15px -5px hsl(var(--drop-bright-white) / 0.25), inset -2px 2px 15px -5px hsl(var(--drop-fade-white) / 0.5), 0 0 0.5px 1px inset rgba(255, 255, 255, 0.5), 0 0 0 0 rgb(255, 255, 255);\n\n  &.is-hovered {\n    transform: rotate3d(1, 0, 0, 0deg) scaleX(0.925) scaleY(1);\n    // box-shadow: var(--shadow-side-anim-end);\n    box-shadow: var(--shadow-glass-anim), inset -0.5px 0.5px 15px -5px hsl(var(--drop-light-white) / 0.25), inset 1px -1px 15px -5px hsl(var(--drop-bright-white) / 0.25), inset -2px 2px 15px -5px hsl(var(--drop-fade-white) / 0.5), 0 0 0.5px 1px inset rgba(255, 255, 255, 0.5), 0 0 0 0 rgb(255, 255, 255);\n  }\n\n  // &.is-active {\n  //   transform: rotate3d(1, 0, 0, 20deg) scaleX(0.975) scaleY(0.95);\n  //   box-shadow: var(--shadow-glass-anim-end), inset -0.5px 0.5px 2px hsl(var(--drop-light-black) / 0.25), inset 1px -1px 3px hsl(var(--drop-bright-black) / 0.25), inset -2px 2px 5px hsl(var(--drop-fade-black) / 0.5), 0 0 0.5px 1px inset rgba(255, 255, 255, 0.5), 0 0 0 0 rgb(255, 255, 255);\n  //   // box-shadow: var(--shadow-h);\n  // }\n}\n\n.button {\n  cursor: pointer;\n  display: flex;\n  flex: 1;\n  position: relative;\n  pointer-events: auto;\n  z-index: 3;\n  background: linear-gradient(-75deg,\n      var(--clear-color),\n      var(--clear2-color),\n      var(--clear3-color));\n  border-radius: var(--border-radii);\n  overflow: hidden;\n  // backdrop-filter: blur(clamp(5px, 0.125em, 10px));\n  // -webkit-backdrop-filter: blur(clamp(5px, 0.125em, 10px));\n  // -moz-backdrop-filter: blur(clamp(5px, 0.125em, 10px));\n  // -ms-backdrop-filter: blur(clamp(5px, 0.125em, 10px));\n  transition: all var(--anim--hover-time) var(--anim--hover-ease);\n\n\n}\n\n:host(.is-hovered) .button {\n\n  backdrop-filter: blur(0.01em);\n  -webkit-backdrop-filter: blur(0.01em);\n  -moz-backdrop-filter: blur(0.01em);\n  -ms-backdrop-filter: blur(0.01em);\n\n}\n\n.inData {\n   \tbackground-image: linear-gradient(hsla(0,0%,0%,0.2),hsla(0,0%,0%,0));\n\n  // Renamed from .span for clarity\n  position: relative;\n  display: flex;\n  flex: 1;\n  border-radius: var(--border-radii);\n  align-items: center;\n  justify-content: space-evenly;\n  flex-direction: row-reverse;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  letter-spacing: 1px;\n  font-size: 1em;\n  color: var(--text-color);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  transition: all var(--anim--hover-time) var(--anim--hover-ease);\n  padding: 0vw;\n  min-height: 100%;\n  box-shadow:\n  0 -0.125em 0.25em hsla(0,0%,0%,0.2),\n  0 0.25em 0.25em hsla(var(--ion-glass-secondary),var(--ion-glow-secondary),var(--ion-satur-secondary),0.25),\n  0 0 0 0.25em hsla(var(--ion-glass-secondary),var(--ion-glow-secondary),var(--ion-satur-secondary),0.25),\n  0 0.375em 0.5em hsla(var(--ion-glass-secondary),var(--ion-glow-secondary),var(--ion-satur-secondary),0.25) inset,\n  0 -0.125em 0.375em hsla(var(--ion-glass-secondary),var(--ion-glow-secondary),var(--ion-satur-secondary),0.14) inset,\n  0 -1.25em 2em 0.5em hsla(var(--ion-glass-secondary),var(--ion-glow-secondary),var(--ion-satur-secondary),0.13) inset,\n  0 1.25em 0.5em 0em hsla(var(--ion-glass-secondary),var(--ion-glow-secondary),var(--ion-satur-secondary),0.13) inset,\n  0 5em 3em hsla(0,0%,0%,0.4);\n\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  -moz-backdrop-filter: blur(12px);\n  -ms-backdrop-filter: blur(12px);\n  overflow: hidden;\n}\n.inData::before{\n  \tbackground: radial-gradient(100% 100% at center,hsla(var(--ion-glass-secondary),var(--ion-glow-secondary),80%,0.25),hsla(var(--ion-glass-secondary),var(--ion-glow-secondary),80%,0) 50%);\n\tcontent: \"\";\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0%;\n\twidth: 100%;\n\theight: 100%;\n\ttransform: translateX(0%);\n  overflow: hidden;\n}\n.disabledBtn {\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
